import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { SUPPORT_EMAIL } from '../constants';
import useHead from '../useHead';

export default function Privacy() {
  useHead({
    title: 'Privacy Policy — ConvoLines',
    description:
      'How ConvoLines collects, uses, and protects your data, including account information, usage data, advertising, and subscription handling.',
    path: '/privacy',
  });

  return (
    <div className="page">
      <Header />
      <section className="section legal">
        <h1>Privacy Policy</h1>
        <p>Last updated: October 2, 2026</p>

        <h2>What we collect</h2>
        <p>
          ConvoLines collects your email address for account creation and sign-in, and
          basic usage data (such as which conversations and quizzes you complete) to
          track your streak and progress. Practice streak data is stored locally on
          your device and is not sent to our servers.
        </p>

        <h2>How we use it</h2>
        <p>
          We use your data to operate your account, sync your favorites and progress
          across devices, process subscriptions through RevenueCat, show ads to users
          on the free plan, and improve the app. We do not sell your personal data.
        </p>

        <h2>Third parties</h2>
        <p>
          We use RevenueCat to manage subscriptions and app store purchases. Payment
          is handled by Apple App Store or Google Play — we never see your payment
          details directly.
        </p>

        <h2>Advertising</h2>
        <p>
          ConvoLines is free and supported by ads, served by Google AdMob. To show and
          measure ads, Google may collect your device's advertising identifier, IP
          address, approximate location, and how you interact with ads. On iOS we only
          use the advertising identifier for personalized ads if you allow tracking when
          asked; in the EEA, UK, and some US states you are asked for your choices
          before any ads are shown. You can change these choices at any time in your
          device settings. Premium subscribers see no ads. Learn more about how Google
          uses data at{' '}
          <a href="https://policies.google.com/technologies/partner-sites">
            policies.google.com/technologies/partner-sites
          </a>
          .
        </p>

        <h2>Data retention</h2>
        <p>
          We retain your account data for as long as your account is active. You can
          request deletion of your account and associated data at any time.
        </p>

        <h2>Your rights</h2>
        <p>
          You can request access to, correction of, or deletion of your personal data
          by contacting us below.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about this policy? Email us at{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
        </p>
      </section>
      <Footer />
    </div>
  );
}
